import React, { useEffect, useState, useContext } from 'react';
import { useHistory } from "react-router-dom";
import toastError from "../../errors/toastError";
import api from "../../services/api";

import Avatar from "@material-ui/core/Avatar";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";

import { AuthContext } from "../../context/Auth/AuthContext";
import { usePrivacyCensorSettings } from "../../utils/privacyCensor";

import { Button, Divider, } from "@material-ui/core";

const VcardPreview = ({ contact, numbers, connectionId }) => {
    const history = useHistory();
    const { user } = useContext(AuthContext);
    const privacyCensorSettings = usePrivacyCensorSettings(user?.id);

    const [selectedContact, setContact] = useState({
        name: "",
        number: 0,
        profilePicUrl: ""
    });

    useEffect(() => {
        const delayDebounceFn = setTimeout(() => {
            const fetchContacts = async () => {
                try {
                    let contactObj = {
                        name: contact,
                        // number: numbers.replace(/\D/g, ""),
                        number: numbers !== undefined && numbers.replace(/\D/g, ""),
                        email: ""
                    }
                    const { data } = await api.post("/contact", contactObj);
                    setContact(data)

                } catch (err) {
                    console.log(err)
                    toastError(err);
                }
            };
            fetchContacts();
        }, 500);
        return () => clearTimeout(delayDebounceFn);
    }, [contact, numbers]);

    const handleNewChat = async () => {
        try {
            const { data: ticket } = await api.post("/tickets", {
                contactId: selectedContact.id,
                userId: user.id,
                status: "open",
                connectionId,
            });
            history.push(`/tickets/${ticket.id}`);
        } catch (err) {
            toastError(err);
        }
    }

    return (
        <>
            <div style={{
                minWidth: "250px",
                maxWidth: "330px",
                padding: "8px 8px 4px",
            }}>
                <Grid container spacing={1} alignItems="center">
                    <Grid item xs={2}>
                        <Avatar
                            src={privacyCensorSettings.contactPhotos ? undefined : selectedContact.profilePicUrl}
                            style={{
                                width: 40,
                                height: 40,
                                backgroundColor: "#dfe5e7",
                                color: "#667781",
                            }}
                        />
                    </Grid>
                    <Grid item xs={9}>
                        <Typography
                            style={{
                                marginLeft: "10px",
                                fontSize: 15,
                                fontWeight: 600,
                                lineHeight: "20px",
                                color: "#111b21",
                                overflowWrap: "anywhere",
                            }}
                            variant="subtitle1"
                            gutterBottom
                        >
                            {privacyCensorSettings.contactNames
                                ? "Contacto privado"
                                : selectedContact.name}
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Divider style={{ backgroundColor: "rgba(134, 150, 160, 0.25)" }} />
                        <Button
                            fullWidth
                            color="primary"
                            onClick={handleNewChat}
                            disabled={!selectedContact.number || !connectionId}
                            style={{
                                color: "#008069",
                                fontSize: 13,
                                fontWeight: 500,
                                textTransform: "none",
                                paddingTop: 8,
                            }}
                        >Conversar</Button>
                    </Grid>
                </Grid>
            </div>
        </>
    );

};

export default VcardPreview;
